function sortArrayByProperty(arrayToSort, property) {
  return [...arrayToSort].sort((a, b) => a[property].localeCompare(b[property]));
}

export { sortArrayByProperty };
//# sourceMappingURL=sortArrayByProperty.mjs.map
